import { ChevronRight } from '@interhyp/platform-icons';
import classNames from 'classnames';
import React, { forwardRef } from 'react';
import { BreadcrumbItem } from "./components/BreadcrumbItem.js";
import styles from "./Breadcrumbs.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const Breadcrumbs = /*#__PURE__*/forwardRef(({
  breadcrumbs,
  className,
  wrapperComponent
}, ref) => {
  return /*#__PURE__*/_jsx("div", {
    className: classNames(styles.breadcrumbs, className),
    children: breadcrumbs.map((breadcrumb, index) => /*#__PURE__*/_jsxs("div", {
      className: styles.breadcrumb,
      children: [/*#__PURE__*/_jsx(BreadcrumbItem, {
        breadcrumb: breadcrumb,
        wrapperComponent: wrapperComponent,
        active: index === breadcrumbs.length - 1
      }), index < breadcrumbs.length - 1 && /*#__PURE__*/_jsx(ChevronRight, {
        className: styles.forwardIcon
      })]
    }, breadcrumb.href))
  });
});